var config = {
  api: {
    basePath: process.env.VUE_APP_API_BASE_PATH
  },
  keycloak: {
    url: process.env.VUE_APP_KEYCLOAK_URL,
    realm: process.env.VUE_APP_KEYCLOAK_REAL,
    clientId: process.env.VUE_APP_KEYCLOAK_CLIENTID,
    flow: "standard",
    onLoad: "login-required",
    checkLoginIframe : false,
  }
};

export default config;
